import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useCompanyInformation } from "../application/Hooks/useCompanyInformation";
import { useGetDesignIndexFieldList } from "../application/Hooks/useGetDesignIndexFieldList";

const Storage = () => {
  const [selectedCompanyIdValue, setSelectedCompanyIdValue] = useState(0);

  const { CompanyData, loading, error } = useCompanyInformation(
    selectedCompanyIdValue
  );
  const { designIndexFieldList, loading1, error1, refetch } =
    useGetDesignIndexFieldList(selectedCompanyIdValue); // assuming refetch is available from your hook

  useEffect(() => {
    const fetchData = () => {
      if (
        designIndexFieldList &&
        designIndexFieldList.indexFields &&
        designIndexFieldList.indexFields.length > 0
      ) {
        setSelectedCompanyIdValue(designIndexFieldList.companyid);
      }
    };
    // Call fetchData inside useEffect
    fetchData();
  }, [designIndexFieldList]);

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <div className="page_wrp"></div>
          <div className="page_title">Storage</div>
          <div className="tab_wrp">
            <div className="row">
              <div className="col-md-12">
                <div className="storage_Wrp">
                  <div className="storage_Wrp_div_1">
                    <i className="fa fa-database" aria-hidden="true"></i>
                    <span>Storage Occupied</span>
                  </div>
                  <div className="storage_Wrp_div_2">
                    <span>
                      {" "}
                      {(() => {
                        const storageInMB = CompanyData.storage / (1024 * 1024);
                        const storageInGB = storageInMB / 1024;
                        return storageInGB >= 1
                          ? `${storageInGB.toFixed(2)} GB`
                          : `${storageInMB.toFixed(2)} MB`;
                      })()}
                    </span>
                  </div>
                </div>

                <p className="Update_text mt-3">
                  Last Update:{" "}
                  {new Intl.DateTimeFormat("en-GB", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                    hour12: true,
                  }).format(new Date())}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Storage;
